import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {KeyboardArrowDown, Clear} from '@mui/icons-material'
import Menu from '@mui/material/Menu'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import {listFilter} from 'utils/utils'

const Filter = styled.div`
    display: flex;
    margin-left: auto;
    align-items: center;
    cursor: pointer;
    width: 200px;
    font-size: 14px;
    margin-right: 50px;
    position: relative;

    > div {
        margin-right: auto;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    &:before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    }

    :hover {
        &:before {
            border-bottom: 2px solid #4a4a4a;
        }
    }
`

const Arrow = styled(KeyboardArrowDown)`
	font-size: 22px;
	transform: ${props => props.open ? 'rotate(180deg)' : ''};
`

const Field = styled(TextField)`
	width: auto;
	padding: 10px;
	position: sticky;
	top: 0;
	background: #FFFFFF;
	z-index: 1;
	display: flex;
`

class PlanningFilter extends React.Component {
    constructor(props) {
        super(props)

        this.options = []
        this.state = {
            anchorEl: null,
            search: ''
        }
    }

    componentDidUpdate() {
        if (this.props.filter && !this.props.filters.find(item => item.id === this.props.filter)) {
            this.props.setFilter(null, this.props.property)
        }
    }

    handleCloseMenu = () => {
        this.setState({ anchorEl: null, search: '' })
    }

    handleOpenMenu = (e) => {
        this.options = this.props.filters
        this.setState({ anchorEl: e.currentTarget })
    }

    setFilter = (id = null) => {
        this.props.setFilter(id, this.props.property)
        this.handleCloseMenu()
    }

    handleSearch = (e) => {
        this.options = listFilter(this.props.filters, e.currentTarget.value, ['name'])
        this.setState({ search: e.currentTarget.value })
    }

    render() {
        const {intl} = this.props
        const filter =  this.props.filter ? this.props.filters.find(item => item.id === this.props.filter) : null
        const title = filter ? filter.custom ? 
            intl.formatMessage({id: filter.name}) : filter.name : intl.formatMessage({id: "planning.show_all"}, {name: this.props.label})
    

        return (
            <React.Fragment>
                <Filter onClick={this.handleOpenMenu}>
                    <div>
                        {title}
                    </div>
                    {this.props.filter &&
                        <Clear
							sx={{fontSize: 16, marginLeft: '10px'}}
                            onClick={(e) => {
                                e.stopPropagation()
                                this.setFilter()}
                            }
                        />
                    }
                    <Arrow open={!!this.state.anchorEl} />
                </Filter>
                <Menu
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleCloseMenu}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
					PaperProps={{
						sx: {
							width: '200px',
							maxHeight: '250px'
						}
					}}
					MenuListProps={{
						sx: {
							paddingTop: 0
						}
					}}
                >
                    <Field variant="standard"
                        onChange={this.handleSearch}
                        value={this.state.search}
                        onKeyDown={(e) => e.stopPropagation()}
                    />
                    {this.options.map(item =>
                        <MenuItem key={item.id}
                            selected={item.id === this.props.filter}
                            value={item.id}
                            onClick={() => this.setFilter(item.id)}
                        >
                            <Typography variant='inherit' noWrap sx={item.custom && {fontWeight: 500}}>
                                {item.custom ? intl.formatMessage({id: item.name}) : item.name}
                            </Typography>
                        </MenuItem>
                    )}
                </Menu>
            </React.Fragment>
        )
    }
}

export default injectIntl(PlanningFilter)
